import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from 'react';
import styled, { css } from 'styled-components';
import { showChat } from '../../../../../utils/liveChat';
import Badge from '../../../../common/base/Badge';
import Button, { ClickableArea } from '../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../common/base/Card';
import Icon from '../../../../common/base/Icon';
import Text from '../../../../common/base/Text';
import Tooltip from '../../../../common/base/Tooltip';
import CopyableField from '../../../../common/CopyableField';
import { Div } from '../../../../common/helpers/StyledUtils';
import { DashboardContext } from '../../DashboardContext';
interface Props {
  context: {
    source: any;
  };
  nextStep: () => void;
  is_current_step: boolean;
}
const StyledCardStatus = styled(StyledCard)<{
  connected: boolean;
}>(({
  theme
}) => css`
    background:
      linear-gradient(
        90deg,
        ${theme.colors.surface.base.surface} 0%,
        ${theme.colors.surface.base.surface}80 100%
      ),
      url(${`/images/background_lines_${theme.mode}.svg`}) no-repeat center center;
  `);
const ConnectCLI: React.FC<Props> = t0 => {
  const $ = _c(47);
  const {
    context,
    nextStep,
    is_current_step
  } = t0;
  const {
    source
  } = context;
  const [show_output, setShowOutput] = useState(false);
  const {
    team,
    active_cli_sessions
  } = useContext(DashboardContext);
  const cli_connected = active_cli_sessions && active_cli_sessions.length > 0;
  const connect_command = source ? `hookdeck listen 3000 ${source.name} --path /webhooks` : "hookdeck listen 3000 source-name --path /webhooks";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <StyledCardSection p={3}><Icon icon="info" muted={true} small={true} left={true} />Run the below in a new terminal window, and do not close it.</StyledCardSection>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      x: 3,
      y: 3,
      r: 4.5
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== connect_command) {
    t3 = <StyledCard overflow_hidden={true}>{t1}<StyledCardSection><CopyableField value={connect_command} mono={true} variant="command_list" borderless={true} p={t2} /></StyledCardSection></StyledCard>;
    $[2] = connect_command;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      t: 4
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      y: 0,
      x: 1
    };
    t6 = {
      l: -1
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      width: "auto"
    };
    t8 = {
      justify: "flex-start",
      align: "center",
      gap: 1
    };
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== show_output) {
    t9 = () => setShowOutput(!show_output);
    $[9] = show_output;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const t10 = !show_output;
  let t11;
  if ($[11] !== t10) {
    t11 = <Text size="xs" semi={true} muted={t10}>View intended output</Text>;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = show_output ? "arrow_drop_down" : "arrow_right";
  let t13;
  if ($[13] !== t12) {
    t13 = <Icon muted={true} icon={t12} />;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t11 || $[16] !== t13 || $[17] !== t9) {
    t14 = <Div m={t4}><ClickableArea p={t5} m={t6} rounded={true} style={t7} flex={t8} onClick={t9}>{t11}{t13}</ClickableArea></Div>;
    $[15] = t11;
    $[16] = t13;
    $[17] = t9;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== show_output || $[20] !== source?.id || $[21] !== source?.name || $[22] !== team?.id) {
    t15 = show_output && <StyledCard overflow_hidden={true} m={{
      t: 2
    }} borderless={false}><StyledCardSection muted={true} p={3} style={{
        overflowX: "scroll",
        whiteSpace: "nowrap"
      }}><Text mono={true} size="s">●── HOOKDECK CLI ──●<br /><br />Listening on 1 source • 1 connection • [i] Collapse<br /><br />{source?.name}<br />│{"  "}Requests to → https://hkdk.events/{source?.id}<br />└─ Forwards to → http://localhost:3030/webhooks (cli-http)<br /><br />{"\uD83D\uDCA1 View dashboard to inspect, retry & bookmark events: https://dashboard.hookdeck.com/events/cli?team_id="}{team?.id}<br /><br />Events • [↑↓] Navigate ────────────────────────────────────────────────────────────────────────────────────────────────<br /><br />○ Connected. Waiting for events...</Text></StyledCardSection></StyledCard>;
    $[19] = show_output;
    $[20] = source?.id;
    $[21] = source?.name;
    $[22] = team?.id;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      t: 6
    };
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      justify: "space-between",
      align: "center",
      gap: 2
    };
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  let t19;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      align: "center"
    };
    t19 = <Text semi={true}>CLI Status</Text>;
    $[26] = t18;
    $[27] = t19;
  } else {
    t18 = $[26];
    t19 = $[27];
  }
  let t20;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      label: "My local server isn't connecting to the CLI",
      icon: "help",
      onClick: _temp
    };
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Div flex={t18}>{t19}<Tooltip tooltip="When you successfully connect your local server to the Hookdeck CLI, the badge to the right will indicate 'Connected,' and you'll be able to proceed to the next step." cta={t20} max_width={380}><Icon icon="info" muted={true} right={true} pointer={true} /></Tooltip></Div>;
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  let t22;
  if ($[30] !== cli_connected) {
    t22 = cli_connected ? <Badge success={true} subtle={true} icon="done_all">Connected</Badge> : <Badge neutral={true} icon="disconnect">Not connected</Badge>;
    $[30] = cli_connected;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== cli_connected || $[33] !== t22) {
    t23 = <Div m={t16}><StyledCardStatus p={3} connected={cli_connected} flex={t17}>{t21}{t22}</StyledCardStatus></Div>;
    $[32] = cli_connected;
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = {
      t: 8
    };
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  const t25 = cli_connected && is_current_step;
  const t26 = !cli_connected || !is_current_step;
  const t27 = !cli_connected;
  let t28;
  if ($[36] !== nextStep || $[37] !== t25 || $[38] !== t26 || $[39] !== t27) {
    t28 = <Div m={t24}><Button primary={t25} outline={t26} onClick={nextStep} disabled={t27}>Next</Button></Div>;
    $[36] = nextStep;
    $[37] = t25;
    $[38] = t26;
    $[39] = t27;
    $[40] = t28;
  } else {
    t28 = $[40];
  }
  let t29;
  if ($[41] !== t14 || $[42] !== t15 || $[43] !== t23 || $[44] !== t28 || $[45] !== t3) {
    t29 = <Div>{t3}{t14}{t15}{t23}{t28}</Div>;
    $[41] = t14;
    $[42] = t15;
    $[43] = t23;
    $[44] = t28;
    $[45] = t3;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  return t29;
};
export default ConnectCLI;
function _temp() {
  showChat();
}